import { render, staticRenderFns } from "./GamePurchaseDialogs.vue?vue&type=template&id=5b9d1fda&scoped=true"
import script from "./GamePurchaseDialogs.vue?vue&type=script&lang=js"
export * from "./GamePurchaseDialogs.vue?vue&type=script&lang=js"
import style0 from "./GamePurchaseDialogs.vue?vue&type=style&index=0&id=5b9d1fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d1fda",
  null
  
)

export default component.exports